export default __webpack_public_path__ + "static/media/loading.47704b07.gif";